import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTruck = () => {
  return (
    <g>
      <path d="m14.59 1.2607h-6.2077a1.3186 1.3186 0 0 0 -1.3173 1.3169v.0664h-2.7364a1.9174 1.9174 0 0 0 -1.627.895l-2.2255 3.5152a2.4663 2.4663 0 0 0 -.2081.4622.67.67 0 0 0 -.0466.1036 2.4634 2.4634 0 0 0 -.1292.7593v3.4736a1.3963 1.3963 0 0 0 1.3945 1.3945h1.1785a2.17 2.17 0 0 0 4.0994 0h2.593a2.1692 2.1692 0 0 0 4.1217 0h1.1107a1.3186 1.3186 0 0 0 1.3177-1.3174v-9.3524a1.3185 1.3185 0 0 0 -1.3177-1.3169zm-10.7057 3.0274a.5248.5248 0 0 1 .4443-.2436l2.7364-.0009v3.0995h-4.9878zm.83 9.0166a.783.783 0 1 1 .7832-.7832.7832.7832 0 0 1 -.7831.7832zm6.7041.0342a.783.783 0 1 1 .7769-.8139c0 .0077-.0045.0142-.0045.0219 0 .0111.0058.02.0063.0312a.7814.7814 0 0 1 -.7786.7608zm3.0889-1.4922h-1.0337a2.17 2.17 0 0 0 -4.11 0h-2.5836a2.1683 2.1683 0 0 0 -4.1315.002l-1.1561.0039v-3.3091h6.2727a.7.7 0 0 0 .7-.7v-5.1824h6.042z" />
    </g>
  );
};

export default withIcon(IconTruck);
